module.exports = __webpack_public_path__ + "static/img/2.f82e422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3/2.png
// module id = SSwc
// module chunks = 1